import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { styled } from '@mui/material/styles';

import TabContainer from '../../containers/TabContainer/TabContainer';
import ContextStore from '../../modules/context';
import FabAdd from '../../components/FabAdd';
import ScrapFormTab from './ScrapFormTab';

const Root = styled('div')(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

function StockRequisition() {
  const { formatMessage } = useIntl()
  const { setBreadcrumbs, currentUser } = useContext(ContextStore)
  const navigate = useNavigate()
  const location = useLocation()
  const [activeTabIndex, setActiveTabIndex] = useState(undefined)
  const { tabName } = useParams()

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.stock.scrapForm' })
    }])
    const pathname = location.pathname
    if (pathname === '/stock/scrapForm/pending' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    } else if (pathname === '/stock/scrapForm/done' && activeTabIndex !== 1) {
      setActiveTabIndex(1)
    }
    return () => {
    };
  }, [location.pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/stock/scrapForm/pending');
    } else if (tabIndex === 1) {
      navigate('/stock/scrapForm/done');
    }
  };

  const tabs = [
    { label: formatMessage({ id: 'scrapForm.tab.pending' }), component: <ScrapFormTab /> },
    { label: formatMessage({ id: 'scrapForm.tab.done' }), component: <ScrapFormTab /> },
  ]
  const defaultSelect = tabName === 'void' ? 2 : (tabName === 'done' ? 1 : 0)

  return (
    <Root>
      {currentUser.userRights['scrapForm-create'] === true && <FabAdd to="/stock/scrapForm/edit/new" />}
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={defaultSelect} tabs={tabs} onTabSelected={onTabSelected} />
    </Root>
  );
}

export default StockRequisition;
